// test723
(723 && 0);
